import type { FlexProps } from "@chakra-ui/layout";
import { Flex } from "@chakra-ui/layout";
import { Portal, useBreakpointValue } from "@chakra-ui/react";
// @ts-ignore - colord has module resolution issues in strict mode
import { colord } from "colord";
import { motion } from "framer-motion";
import styled from "styled-components";
import { appTheme } from "@styles/Theme";
import { Back } from "./button/Back";

interface Props extends FlexProps {
	onBack?: () => any;
	children?: React.ReactNode;
}

export const Sidebar: React.FC<Props> = ({ onBack, children, ...flexProps }) => {
	const width = useBreakpointValue(
		{ base: "100vw", md: "330px" },
		{
			ssr: false, // Changed from true (Next.js SSR not applicable in Vite)
		},
	);

	return (
		<Portal>
			<motion.div
				initial={{
					position: "absolute",
					translateX: 400,
					right: 0,
					top: 0,
					opacity: 0,
					width,
					zIndex: 10,
				}}
				animate={{
					translateX: 0,
					opacity: 1,
				}}
				transition={{
					ease: "easeOut",
					duration: 0.15,
				}}
			>
				<Flex
					direction={"column"}
					bg={"white"}
					h="100vh"
					w={width}
					p="1.5rem"
					border="1px solid #ccc"
					borderRadius={{ base: "0", md: "30px 0 0 30px" }}
					borderRightStyle="none"
					gap="1rem"
					{...flexProps}
				>
					<Styles>
						<Back onClick={onBack} />
						<div className="content">{children}</div>
					</Styles>
				</Flex>
			</motion.div>
		</Portal>
	);
};

const Styles = styled.div`
	.title {
		font-style: normal;
		font-weight: 600;
		font-size: 20px;
		line-height: 24px;
		color: ${appTheme.colors.darker};
		margin-top: 0.5rem;
	}

	.save-btn {
		width: 100%;
		border-radius: 0;
		height: 30px;
		margin-top: 1.5rem;
	}

	.choices {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1rem;
		min-height: 250px;
	}

	.checkbox-choices {
		display: inline-flex;
		flex-wrap: wrap;
		gap: 0.5rem;
		align-items: flex-start;
	}

	.checkbox-choice {
		border: 2px solid ${(props) => props.theme.colors.brand};
		background-color: ${(props) => colord(props.theme.colors.brand).lighten(0.5).toHex()};
		text-align: center;
		padding: 0.3rem 0.5rem;
		border-radius: 25px;
		font-weight: 500;
		position: relative;
		cursor: pointer;
		font-size: 14px;

		transition: transform 0.125s;

		&:hover {
			background-color: ${(props) => colord(props.theme.colors.brand).lighten(0.45).toHex()};
			transform: scale(0.99);
		}

		&.active-choice {
			background-color: ${(props) => props.theme.colors.brand};
			color: white;
		}
	}

	.skills {
		margin-bottom: 1.5rem;
	}

	.error {
		color: red;
	}

	.competence-description {
		font-size: ${(props) => props.theme.font.small};
	}

	/* .content {
		overflow-y: auto;
		max-height: calc(100vh - 70px);
	} */
`;
